import request from "@/utils/request";
import Qs from "qs";

export function listLoad() {
  return request({
    url: "/api/login/getMenu.do",
    method: "post"
  });
}
/**
 * 获取getGeoJson
 * @param {*} params
 * @returns
 */
export function getGeoJson(code) {
  return request({
    baseURL: "/apiGeoJson",
    url: `/area/${code}.json`,
    method: "get"
  });
}
/**企业模糊匹配 */
export function getEntByKeyword(params) {
  return request({
    url: "/common/getEntByKeyword",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**账号验证 */
export function isRegister(params) {
  return request({
    url: "/user/isRegister",
    method: "post",
    data: Qs.stringify(params)
  });
}

/**手机验证码 */
export function getPhoneCode(params) {
  return request({
    url: "/common/verificationCode",
    method: "post",
    data: Qs.stringify(params)
  });
}

/**用户注册 */
export function getRegisterUser(params) {
  return request({
    url: "/common/registerUser",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**用户注册-修改 */
export function getRegisterUserEdit(params) {
  return request({
    url: "/personalCenter/updateUserInfo2",
    method: "post",
    data: Qs.stringify(params)
  });
}

/**忘记密码 */
export function getForgetPassword(params) {
  return request({
    url: "/common/forgetPassword",
    method: "post",
    data: Qs.stringify(params)
  });
}

/**产业 */
export function getIndustry(params) {
  return request({
    url: "/common/lx1",
    method: "post",
    data: Qs.stringify(params)
  });
}
export function getList(params) {
  return request({
    url: "/common/lx2",
    method: "post",
    data: Qs.stringify(params)
  });
}
export function getComSearch(params) {
  return request({
    url: "/common/search",
    method: "post",
    data: Qs.stringify(params)
  });
}

/************************************************************政策部分
 * 政策筛选框
 * @param {*} params
 * @returns
 */
export function getDropDown(params) {
  return request({
    url: "/common/dropDown",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 *
 * @returns 获取用户信息
 */
export function getByToken2() {
  return request({
    url: "/userInfo/getByToken2",
    method: "post"
  });
}
